import React, { useState, useEffect } from 'react';
import config from '../config/config';
import { getWeatherPageURL } from '../services/weatherInfoService';

const WEATHER_ICON_BASE_URL = config.weather.iconBaseURL;
const WEATHER_ICON_EXT = config.weather.iconExt;
const DEFAULT_WEATHER_CODE = config.weather.defaultWeatherCode;
const TEMPERATURE_UNKNOWN_LABEL = config.weather.temperatureUnknownLabel;
const DEGREE_SYMBOL = config.weather.degreeSymbol;
const WEATHER_ICON_ALT = 'Weather Icon';
/**
 * 天気コンポーネント
 */
const WeatherInfo = ({ weather }) => {

  // 天気アイコンの表示フラグ（画像が正常にロードできたときだけtrue）
  const [iconVisible, setIconVisible] = useState(false);

  // 天気コードと温度、無ければデフォルトの不明時の値を設定
  const weatherCode = weather?.weather_code ?? DEFAULT_WEATHER_CODE;
  const temperature = weather?.now_temperature ?? TEMPERATURE_UNKNOWN_LABEL;

  // 受け取ったdataの天気コードをもとに、アイコンURLを取得
  const weatherIconUrl = `${WEATHER_ICON_BASE_URL}/${weatherCode}${WEATHER_ICON_EXT}`;

  // アイコンURLが変わったら、いったん非表示に戻す
  useEffect(() => {
    setIconVisible(false);
  }, [weatherIconUrl]);

  // マピオン天気ページのURLを取得
  const weatherPageUrl = getWeatherPageURL(weather)

  // クリックハンドラ、天気ページへ移動
  const handleWeatherClick = () => {
    if (weatherPageUrl) {
      // 新しいタブで開く
      window.open(weatherPageUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className="weather-info-desktop"
      onClick={handleWeatherClick}
    >
      <img
        id="weather-icon-desktop"
        className="weather-icon"
        src={weatherIconUrl}
        alt={WEATHER_ICON_ALT}
        onError={() => setIconVisible(false)}
        onLoad={() => setIconVisible(true)}
        style={{
          display: iconVisible ? 'inline-block' : 'none',
        }}
      />
      {iconVisible && (
        <span className="weather-data">
          <span id="weather-value-desktop">{temperature}</span>
          <span id="weather-unit">{DEGREE_SYMBOL}</span>
        </span>
      )}
    </div>
  );
}

export default WeatherInfo;